import '../index.css';

import Row from 'react-bootstrap/esm/Row';

import Container from 'react-bootstrap/esm/Container';

function About() {

    return (
        <div className='about' >
            <h1 className='aboutHeader shadow'>About</h1>
                <Row className='p-5'>
                    <Container className='justify-content-center' style={{width:'75vw'}}>
                        <p>At Apex Performance, we believe everyone has the potential to transform — no matter where they’re starting from. Built to bridge the gap between science-based fitness and real-world results, Apex Performance combines clinical insight with proven training and nutrition methods to create a realistic, results-driven path for every client.</p>
                        <p className='pt-3'>Our mission is simple: to take clients from average to apex. Each program is custom-built from the ground up around your unique goals, lifestyle, and skill level — from macronutrient-targeted meal plans to progressive resistance training systems — ensuring measurable and sustainable results. Whether your goal is fat loss, muscle gain, or total body recomposition, you’ll have access to professional-grade coaching, daily accountability, and the tools you need to evolve beyond your limits.</p>
                        <p className='pt-3'>Whether you’re just starting your fitness journey or looking to elevate your training, Apex Performance provides the structure, education, and support to help you achieve lasting success.</p>
                        <p className='pt-3'>At Apex Performance, it’s not about quick fixes — it’s about sustainable progress. You’ll learn how to train smarter, fuel your body properly, and build habits that last.</p>
                        <h3 className='pt-2'>Your path to a stronger, healthier you starts here.</h3>
                        <h1 className='pt-3'><b>Train. Eat. Evolve.</b></h1>
                    
                    </Container>
                    
                </Row>
                    
            

        </div>
       
    );
}

export default About;